var o1 = "/static/45853fc5fde121be.png";

export { o1 as default };
//# sourceMappingURL=o_1.png.js.map
